import { render, staticRenderFns } from "./Cakes.vue?vue&type=template&id=79beac25&scoped=true"
import script from "./Cakes.vue?vue&type=script&lang=js"
export * from "./Cakes.vue?vue&type=script&lang=js"
import style0 from "./Cakes.vue?vue&type=style&index=0&id=79beac25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79beac25",
  null
  
)

export default component.exports